<template>
<div v-cloak>
    <div v-if="checkList.page == currentTestPage">
        <div class="preTestWrap">
            <div class="preTestListWrap">
                <ul>
                    <li class="list-group-item" v-for="(item,index) in checkList.body" :key="item">
                        <p  v-html="item"></p>
                        <ul class="preTestList clearfix">
                            <li>
                                <input class="form-check-input" type="radio" value="1" v-model="answer[index]">
                                <label class="form-check-label">전혀 그렇지 않다</label>
                            </li>
                            <li>
                                <input class="form-check-input" type="radio" value="2" v-model="answer[index]">
                                <label class="form-check-label">그렇지 않은 편이다</label>
                            </li>
                            <li>
                                <input class="form-check-input" type="radio" value="3" v-model="answer[index]">
                                <label class="form-check-label">보통이다</label>
                            </li>
                            <li>
                                <input class="form-check-input" type="radio" value="4" v-model="answer[index]">
                                <label class="form-check-label">다소 그런 편이다</label>
                            </li>
                            <li>
                                <input class="form-check-input" type="radio" value="5" v-model="answer[index]">
                                <label class="form-check-label">매우 그렇다</label>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="answer_reset">
                <button v-if="checkList.page != 1" @click="$emit('goPrevious',checkList.page)" class="resetbt sub">이전</button>
                <button @click="goNext" class="resetbt main">제출</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    props : ['checkList','currentTestPage'],
    data(){
        return{
            // answer : [1,2,3,4,5,1,2,3,4,5]
            answer : []
        }
    },
    methods:{
        goNext(){
            console.log(this.checkIfAllAnswered());
            if(this.answer.length < this.checkList.body.length || this.checkIfAllAnswered() ){
                swal('알림','모든 문항에 답변해 주세요.','info');
            }else{
                this.$emit('answered',this.checkList.page,this.answer);
                this.$emit('goNext',this.checkList.page);
            }
        },
        checkIfAllAnswered(){
            let result = false;
            _.forEach(this.answer, function(item) {
                if(isNaN(item)){
                    result = true;
                }
            });
            return result;
        }
    },
    mounted(){
    }
}
</script>